import React from 'react';
import { Clock } from 'lucide-react';

const formatActivityDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: true
    });
};

const StatusTypes = {
    "new": "New",
    "in_review": "In Review",
    "pending_payment": "Pending Payment",
    "portal_fee_payment_pending": "Portal Fee Payment Pending",
    "automation_started": "Automation Started",
    "automation_failed": "Automation Failed",
    "signup_automation_started": "Signup Automation Started",
    "profile_automation_started": "Profile Automation Started",
    "portal_profile_failed": "Portal Profile Failed",
    "payment_received": "Payment Received",
    "added_to_process_queue": "Added to Process Queue",
    "added_to_signup_queue": "Added to Signup Queue",
    "added_to_profile_queue": "Added to Profile Queue",
    "portal_signup_failed": "Portal Signup Failed",
    "permit_processing": "Permit Processing",
    "permit_ready": "Permit Ready",
    "completed": "Completed",
    "on_hold": "On Hold",
    "rejected": "Rejected"
};

const getStatusLabel = (status) => {
    return StatusTypes[status] || status;
};

const ActivityLog = ({ activities = [] }) => {
    if (!activities || activities.length === 0) {
        return (
            <div className="text-muted-foreground py-8 text-center">
                No activity log available
            </div>
        );
    }

    return (
        <div className="pr-2 space-y-4">
            {activities.map((activity, index) => (
                <div key={activity._id || index} className="flex gap-3">
                    {/* Timeline Icon */}
                    <div className="flex flex-col items-center">
                        <div className="flex items-center justify-center w-8 h-8 rounded-full bg-muted border-2 border-background">
                            <Clock className="h-4 w-4 text-muted-foreground" />
                        </div>
                        {/* Vertical line connecting to next item */}
                        {index < activities.length - 1 && (
                            <div className="w-0.5 flex-1 bg-border mt-2 h-8" />
                        )}
                    </div>

                    {/* Activity Content */}
                    <div className="flex-1 pb-6 overflow-x-auto">
                        <div className="space-y-1">
                            {/* Admin name and status change */}
                            <div className="text-sm">
                                <span className="font-semibold">{activity.admin_name || 'System'}</span>
                                {' '}
                                {activity.admin_name ? 'changed status to' : 'Status changed to'}
                                {' '}
                                <span className="font-bold capitalize">
                                    {getStatusLabel(activity.permit_status)}
                                </span>
                                {' '}
                                from {' '}
                                <span className="font-semibold capitalize">
                                    {getStatusLabel(activity.previous_status)}
                                </span>

                            </div>

                            {/* Reason/Message */}
                            {activity.message && (
                                <div className="text-sm text-muted-foreground line-clamp-4">
                                    Reason: {activity.message}
                                </div>
                            )}

                            {/* Date */}
                            <div className="text-xs text-muted-foreground pt-1">
                                {formatActivityDate(activity.createdAt)}
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default ActivityLog;

